// distinguish from ReadBehavior in dataflow-constants
export const copySourceReadBehaviors = {
    query: 'query',
    queryAll: 'queryAll'
};
